export function newsListGet(callback) {
	return {
    type: 'NEWS_LIST_GET',
		callback: callback,
	}
}

export function newsReadEdit(id) {
	return {
		type: 'NEWS_READ_EDIT',
		payload: {
			id: id,
		},
	}
}
